import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private secretKey: any = null;

  constructor() {
  }

  setEncryptionKey(key: string) {
    this.secretKey = key;
    localStorage.setItem('edk', this.secretKey);
  }

  private encrypt(value: any): string {
    if (!this.secretKey) throw new Error('Secret key not set');
    const json = JSON.stringify(value);
    return CryptoJS.AES.encrypt(json, this.secretKey).toString();
  }

  private decrypt(cipherText: string): any {
    if (!this.secretKey){
      this.secretKey = localStorage.getItem('edk');
    }
    if (!this.secretKey) throw new Error('Secret key not set');
    const bytes = CryptoJS.AES.decrypt(cipherText, this.secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  }

  getItem(key: string) {
    const item = localStorage.getItem(key);
    if (!item) return null;
    try {
      return this.decrypt(item);
    } catch (e) {
      console.error('Error decrypting storage item', e);
      return null;
    }
  }

  setItem(key: string, value: any): void {
    try {
      const encrypted = this.encrypt(value);
      localStorage.setItem(key, encrypted);
    } catch (e) {
      console.error('Error encrypting storage item', e);
    }
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
